import React from 'react'
import List from './List'
import AliceCarousel from 'react-alice-carousel';
import two from '../images/solutions/group-2.png'
import four from '../images/solutions/golive-34po.png'
import three from '../images/solutions/intergrate@2x.png'
import one from '../images/solutions/problems@2x.png'


const solutionData = [{
    id:'1',
    title:`Tell us about your business process`,
    step:'step 1',
    discription:"We'll understand your process and design a workflow that's perfect for it.",
    image:one
},{
    id:'2',
    title:'Make it what you want',
    step:'step 2',
    discription:"Choose features, add rules, customize interfaces & automate tasks with ease.",
    image:two
}, {
    id:'3',
    title:'Go live the next day',
    step:'step 3',
    discription:"We'll deliver a powerful business app that works across iOS, Android and Web in record time.",
    image:four
},/*{
    id:'4',
    title:'Integrate',
    step:'Any time',
    discription:'Integrate your current applications with Hubbler for a unified dashboard.',
    image:three
}*/]

class ListItem extends React.Component{
    onClickHandler(event){
        let curElement = event.target
        while(!curElement.classList.contains('list-item')){
            curElement = curElement.parentNode;
        }
        const {itemData} = this.props
        this.props.onClickHandler(itemData.id,curElement,itemData.image)
    }
    render(){
        const {itemData,activeItem,step} = this.props
         return  <li id={itemData.id} className={activeItem === itemData.id ? `active list-item ${itemData.id}` : `list-item ${itemData.id}`} onClick={this.onClickHandler.bind(this)}>
             <div>
             <div className={'step'}>{itemData.step}</div>
             <div className={'title'}>{itemData.title}</div>
             <div className={'discription'}>{itemData.discription}</div>
             </div>
         </li>
    }
}

export default class Solutions extends React.Component{
    constructor(){
        super()
        this.state = {
            activeItem:'1',
            offsetTop:124,
            previewImage:one
        }
    }
    onClickHandler(id,curElement,previewImage){
        this.setState({
            activeItem:id,
            offsetTop:curElement.offsetTop,
            previewImage
        })
    }
    galleryItems(){
        return <div>test</div>
    }
    render(){
        return <div className={'solutions-cls'}>
            <div className={'solution-list'} data-aos="fade-up"  data-aos-delay="250" >
                <div className={'text-hub'}>Automate your business process in 3 simple steps</div>
                <List items={solutionData} listItem={ListItem} activeItem={this.state.activeItem} onClickHandler={this.onClickHandler.bind(this)}/>
                <div className={'animation-active'} style={{top:this.state.offsetTop}}></div>
            </div>
            <div className={`solution-preview web img-${this.state.activeItem}`} style={{backgroundImage:`url(${this.state.previewImage})`}}></div>
            <div className={'dis-mobile'}>
                <div className={'text-hub mobile'}>How Hubbler digitizes your workflow</div>
                <AliceCarousel autoPlay={false} autoPlayInterval={5000} duration={500}>
                     <div className={'dash'}>
                         <div>
                             <div className={'step'}>Step 1</div>
                             <div className={'title'}>Tell us about your business process</div>
                             <div className={'discription'}>We'll understand your process and design a workflow that's perfect for you.</div>
                         </div>
                         <div className={'solution-preview'} data-aos="fade-up" style={{backgroundImage:`url(${one})`}}></div>
                     </div>
                    <div className={'dash'}>
                        <div>
                            <div className={'step'}>step 2</div>
                            <div className={'title'}>Choose your features like toppings for a sub</div>
                            <div className={'discription'}>Choose your features, modify the interface, set the business rules and approval workflows  - and we’ll get it done for you.</div>
                        </div>
                        <div className={'solution-preview'} data-aos="fade-up" style={{backgroundImage:`url(${two})`}}></div>
                    </div>
                    <div className={'dash'}>
                        <div>
                            <div className={'step'}>step 3</div>
                            <div className={'title'}>Go live the next day</div>
                            <div className={'discription'}>We'll deliver a powerful, fully-automated business app for your team across iOS, Android and Web in record time.</div>
                        </div>
                        <div className={'solution-preview'} data-aos="fade-up" style={{backgroundImage:`url(${four})`}}></div>
                    </div>
                   {/* <div className={'dash'}>
                        <div>
                            <div className={'step'}>Any time</div>
                            <div className={'title'}>Integrate</div>
                            <div className={'discription'}>Integrate your current applications with Hubbler for a unified dashboard.</div>
                        </div>
                        <div className={'solution-preview'} data-aos="fade-up" style={{backgroundImage:`url(${three})`}}></div>
                    </div>*/}
                </AliceCarousel>
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/Solutions.js